<template>
  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <template v-for="(item, index) in list">
      <van-swipe-item
        @click="itemClick(item)"
        :key="index"
        v-if="item.title != '' && item.title"
        class="bg-img"
      >
        <h2 class="swipe-title">{{ item.title }}</h2>
        <p class="swipe-p">{{ item.content }}</p>
      </van-swipe-item>
      <van-swipe-item :key="index + 'item'" v-else @click="itemClick(item)">
        <img :src="$config.fileImg + item.url" alt="" />
      </van-swipe-item>
    </template>
  </van-swipe>
</template>
<script>
import { Swipe, SwipeItem } from "vant";
import common from "@/common/old/public/common";
export default {
  name: "pi-swipe",
  data() {
    return {};
  },
  methods: {
    itemClick(item) {
      console.log(item);
      if (item.bannerDetailContent && item.bannerDetailTitle) {
        common.save("home-banner-details", item);
        this.$router.push("/home/banner-details");
      } else if (item.campaignPkId) {
        if (item.campaignType != 4) {
          this.$router.push(
            "/activity-details?campaignPkId=" +
              item.campaignPkId +
              "&campaignType=" +
              item.campaignType
          );
        }
      } else {
        this.$router.push("/notice-content?id=" + item.noticePkId);
      }
    },
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
<style lang="less">
.my-swipe {
  height: 100%;
}
.my-swipe .van-swipe-item {
  color: #333;
  font-size: 20px;

  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
}
.my-swipe .van-swipe-item.bg-img {
  background-image: url("../../assets/image/banner-test.png");
  background-size: 100% 100%;
  text-align: left;
  padding: 0.1rem 0.2rem;
  color: #fff;
  box-sizing: border-box;
  .swipe-title {
    font-size: 0.6rem;
    line-height: 0.84rem;
  }
  .swipe-p {
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #f2f7b0;
  }
}
</style>
